import Vue from 'vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import request from '@/request'
import '@/assets/css/reset.css'
import 'vant/lib/index.css'
import '@/assets/css/animated.css'
import App from './App.vue'

let orignalSetItem = window.localStorage.setItem // 原生localStorage.setItem方法
localStorage.setItem = function(key, newValue) {
  let setItemEvent = new Event('setItemEvent') // 重写注册setItem
  setItemEvent.key = key
  setItemEvent.newValue = newValue
  window.dispatchEvent(setItemEvent) // 派发setItem
  orignalSetItem.apply(this, arguments) // 设置值
}
// import fastclick from 'fastclick';
// fastclick.attach(document.body);

// import Vconsole from 'vconsole';
// let vConsole = new Vconsole();
// 如果全局引入，使用时 this.$toast()
import { Loading, Toast } from 'vant'
Vue.use(request)
  .use(Loading)
  .use(Toast)

// 全局过滤器
// import {
//     imgUrlDomain
// } from '@/request/api';
// Vue.filter('picFilter', function (value) {
//     if (!value) return
//     if (value.indexOf("http") != -1) {
//         return value;
//     } else {
//         return imgUrlDomain + value;
//     }
// })

Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
